import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useSelector } from 'react-redux';

import { getSelectorBasedStoreValue } from 'v2/modules/withRunForm/redux/selector';
import { getQuantModes, defaultUiBehaviourFlags } from 'v2/modules/withRunForm/configs/index';
import HoverMessage from 'common/components/HoverMessage';

const propTypes = {
  isPipeIntent: PropTypes.bool,
  isBookProfitTsl: PropTypes.bool,
};
const defaultProps = {
  isPipeIntent: false,
  isBookProfitTsl: false,
};

const renderQuickAdjustments = () => {
  return (
    <div className="transaction_details-items quick-adjustments">
      Quick Adjustments
      <img src="/v3Crown.png" className="v2-crown-image" alt="" />
    </div>
  );
};

const stopLossDelayByToolTipContent = (
  <div>
    If the price is beyond stop loss for configured delay by time, then it is exited.
    <br />
    <br />
    If the price fluctutates and not stays beyond stop loss for configured delay by time, then
    it is&nbsp;
    <b>ignored</b>
    .
    <br />
    <br />
    <b>Note:</b>
    &nbsp;
    If delay by is set,&nbsp;
    <b>SL orders will not be placed to the broker</b>
    &nbsp;in Live Deployments.
  </div>
);

const IntentHeaders = ({ isPipeIntent, isBookProfitTsl }) => {
  const uiBehaviourFlags = useSelector(
    (state) => getSelectorBasedStoreValue(state, 'quantConfig.uiBehaviourFlags')
  );
  const maxInstrumentsInGroup = useSelector(
    (state) => getSelectorBasedStoreValue(state, 'quantConfig.maxInstrumentsInGroup')
  );
  // TODO: Copied from useOpenIntent, DRY it.
  const mode = useSelector(
    (state) => getSelectorBasedStoreValue(state, 'quantConfig.uiConfigs.mode')
  ) || getQuantModes.simple.value;
  const isAdvancedMode = useMemo(() => mode === getQuantModes.advanced.value, [mode]);
  // ------------------------------
  const isShowInstrumentIndex = useMemo(() => maxInstrumentsInGroup > 1, [maxInstrumentsInGroup]);

  const {
    isReEntry,
    isReExecute,
    isTrailingStopLoss,
    isWaitAndTrade
  } = uiBehaviourFlags || defaultUiBehaviourFlags;

  const renderRenTryOrReExecuteLabel = useMemo(() => {
    if (isReEntry && isReExecute) {
      return 'Re-Entry/Re-Execute';
    }
    if (isReEntry) {
      return 'Re-Entry';
    }

    return 'Re-Execute';
  }, [isReEntry, isReExecute]);

  const instrumentClassName = classNames('transaction_details-items', {
    instrument: !isShowInstrumentIndex,
    with_advanced_mode: isAdvancedMode,
    pair_instrument: isShowInstrumentIndex,
  });

  const slClassNames = classNames('transaction_details-items stop_loss d-flex justify-content-end', {
    'align-to-delay-by': isAdvancedMode,
  });
  return (
    <div className="transaction_details head">
      <div className="transaction_details-items intent-type">Action</div>
      <div className="transaction_details-items segment">Segment</div>
      <div className={instrumentClassName}>Instrument</div>
      <div className="transaction_details-items quantity">Lot</div>
      <div className="transaction_details-items action_type">Action</div>
      <div className={slClassNames}>Stop Loss</div>
      {isAdvancedMode ? (
        <div className="transaction_details-items stop_loss_delay_by d-flex align-items-center">
          Spike
          <span className="material-icons-outlined spike-security-icon">
            security
          </span>
          <HoverMessage title="Spike Protection Delay By" message={stopLossDelayByToolTipContent}>
            <span className="material-icons-outlined info-icon">
              info
            </span>
          </HoverMessage>
        </div>
      ) : null}
      <div className="transaction_details-items take_profit d-flex justify-content-end">Take Profit</div>
      {isTrailingStopLoss && !isPipeIntent
      && (
      <div
        className={
          `transaction_details-items trailing_stop_loss ${isBookProfitTsl ? 'tsl_book_and_linear' : ''}`
        }
      >
        Trailing Stop Loss
      </div>
      )}
      {isWaitAndTrade
        && !isPipeIntent
        && <div className="transaction_details-items wait_and_trade">Wait and Trade</div>}
      {((isReEntry || isReExecute) && !isPipeIntent)
          && (
          <div className="transaction_details-items re_entry_execute">
            {renderRenTryOrReExecuteLabel}
          </div>
          )}
      {!isPipeIntent && renderQuickAdjustments()}
      <div className="transaction_details-items delete" />
    </div>
  );
};

IntentHeaders.propTypes = propTypes;
IntentHeaders.defaultProps = defaultProps;

export default IntentHeaders;
